import React from "react";

const OrderBoxJsx = ({phoneNumber, setPhoneNumber, deliveryName, setDeliveryName, deliveryAddress, setDeliveryAddress, postNumber, setPostNumber, city, setCity, county, setCounty}) => {
    return (
        <div>
            <label htmlFor="phone-number">Telefonnummer</label>
            <input type="text" placeholder="Telefonnummer" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} />

            <label htmlFor="name">Full Namn</label>
            <input type="text" placeholder="Full Namn" value={deliveryName} onChange={(e) => setDeliveryName(e.target.value)} />

            <label htmlFor="address">Adress</label>
            <input type="text" placeholder="Adress" value={deliveryAddress} onChange={(e) => setDeliveryAddress(e.target.value)} />

            <label htmlFor="postNumber">Postnummer</label>
            <input type="text" placeholder="Postnummer" value={postNumber} onChange={(e) => setPostNumber(e.target.value)} />

            <label htmlFor="city">Ort</label>
            <input type="text" placeholder="Ort" value={city} onChange={(e) => setCity(e.target.value)} />

            <label htmlFor="County">Län</label>
            <input type="text" placeholder="Län" value={county} onChange={(e) => setCounty(e.target.value)} />
        </div>
    );
};

export default OrderBoxJsx;
